import {
  addDays,
  eachWeekOfInterval,
  endOfMonth,
  isSameMonth,
  parseISO,
  startOfMonth,
  startOfWeek,
} from 'date-fns'

const WEEK = { weekStartsOn: 1 } as const

/** Mondays of the weeks that overlap the month. */
export const monthWeeks = (month: Date): Date[] =>
  eachWeekOfInterval(
    { start: startOfMonth(month), end: endOfMonth(month) },
    WEEK
  )

/** Days of one week, with the days outside the month left out. */
export const weekDays = (monday: Date, month: Date): (Date | null)[] =>
  Array.from({ length: 7 }, (_, offset) => {
    const day = addDays(monday, offset)
    return isSameMonth(day, month) ? day : null
  })

/**
 * The week to open on: the selected day's, else the last graded day's, else
 * the month's first.
 */
export const initialWeekIndex = (
  month: Date,
  selected: string | null,
  gradedDates: string[]
): number => {
  const weeks = monthWeeks(month)
  const anchor = selected ?? [...gradedDates].sort().at(-1)
  if (!anchor) return 0
  const monday = startOfWeek(parseISO(anchor), WEEK).getTime()
  const index = weeks.findIndex(week => week.getTime() === monday)
  return index === -1 ? 0 : index
}
